export function MetronLogo({ className = "h-9 w-9" }) {
  return <img src="/metron-logo.png" alt="MÉTRON" translate="no" className={`notranslate ${className} object-contain`} />;
}
